import * as React from 'react';
var DrawerContext = /*#__PURE__*/React.createContext(null);
export var RefContext = /*#__PURE__*/React.createContext({});
export default DrawerContext;